import React from 'react';
import { loveLangNames } from '../data/questionData';

const TestResults = ({ scores, maxScore }) => {
  if (maxScore === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-lg text-slate-600">Még nem válaszoltál egyetlen kérdésre sem.</p>
      </div>
    );
  }

  return (
    <div id="results" className="max-w-4xl mx-auto mt-16">
      <div 
        className="bg-white rounded-3xl p-8 lg:p-12 shadow-2xl border border-slate-200"
        style={{
          background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(240,253,250,0.95) 100%)',
          backdropFilter: 'blur(20px)',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
        }}
      >
        <div className="text-center mb-8">
          <h3 className="text-3xl font-bold mb-4 bg-gradient-to-r from-teal-600 to-teal-800 bg-clip-text text-transparent">
            🎉 Az eredményed
          </h3>
        </div>
        
        <div className="space-y-4">
          {loveLangNames
            .map((name, i) => ({ name, score: scores[i], index: i }))
            .sort((a, b) => b.score - a.score)
            .map((item, sortIndex) => {
              const maxScoreValue = Math.max(...scores);
              const isTopScore = item.score === maxScoreValue;
              
              if (isTopScore) {
                return (
                  <div 
                    key={item.index}
                    className="p-6 rounded-2xl transform hover:scale-105 transition-all duration-300"
                    style={{
                      background: 'linear-gradient(135deg, #01918C 0%, #02c7c0 100%)',
                      color: 'white',
                      boxShadow: '0 15px 35px rgba(1, 145, 140, 0.3)'
                    }}
                  >
                    <div className="flex justify-between items-center">
                      <div className="text-2xl font-bold">
                        {item.name}
                      </div>
                      <div 
                        className="px-6 py-3 rounded-full font-bold text-xl"
                        style={{ 
                          backgroundColor: 'rgba(255,255,255,0.2)',
                          backdropFilter: 'blur(10px)'
                        }}
                      >
                        {item.score} pont
                      </div>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div 
                    key={item.index}
                    className="flex justify-between items-center p-4 rounded-xl border-2 bg-slate-50 border-slate-200 transition-all duration-300"
                  >
                    <span className="font-semibold text-slate-700">
                      {item.name}
                    </span>
                    <div className="px-4 py-2 rounded-full font-bold bg-slate-200 text-slate-600">
                      {item.score} pont
                    </div>
                  </div>
                );
              }
            })}

          <div className="bg-slate-50 rounded-2xl p-6 border border-slate-200 mt-8">
            <h4 className="font-bold text-slate-800 mb-3">💡 Mit jelentenek az eredmények?</h4>
            <p className="text-slate-600 leading-relaxed">
              A legmagasabb pontszámú szeretetnyelv az <strong>elsődleges szeretetnyelved</strong>. 
              Ez az a mód, ahogyan leginkább érzed és fogadod be a szeretetet. 
              Ha két nyelv azonos pontszámot ért el, akkor "kétnyelvű" vagy. 
              A többi nyelvet is fontos megértened, mert partnered más nyelven fejezheti ki szeretetét.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestResults;